import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import PromotionDisplay from '@/components/Promotions/PromotionDisplay.vue'
import UserList from '../components/Users/UserList.vue'
import PromotionList from '@/components/Promotions/PromotionList.vue'
import CustomerList from '@/components/Customer/CustomerList.vue'
import SnpMappingList from '@/components/SnpMapping/SnpMappingList.vue'
import { PromotionOption } from '@/models/Enum'
import SalesOrgPage from '@/components/SalesOrg/SalesOrgPage.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    redirect: { name: 'allPromotion', params: { type: PromotionOption.Worklist } }
  },
  {
    path: '/promotion/create',
    name: 'createPromotions',
    component: PromotionDisplay
  },
  {
    path: '/promotions/display',
    name: 'displayPromotions',
    component: PromotionDisplay
  },
  {
    path: '/user',
    name: 'user',
    component: UserList
  },
  {
    path: '/administration/users',
    name: 'userList',
    component: UserList
  },
  {
    path: '/promotions/:option?',
    name: 'allPromotion',
    component: PromotionList
  },
  {
    path: '/promotion/:id',
    name: 'editPromotions',
    component: PromotionDisplay
  },
  {
    path: '/customers',
    name: 'customers',
    component: CustomerList
  },
  {
    path: '/administration/snp-mapping',
    name: 'snp-mapping',
    component: SnpMappingList
  },
  {
    path: '/administration/sales-org',
    name: 'sales-org',
    component: SalesOrgPage
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  const query = Object.assign({}, to.query)
  if (query.jwt) {
    localStorage.setItem('token', query.jwt as string)
    delete to.query.jwt
    delete query.jwt
    router.replace({ query })
  }

  next()
})

export default router
